import {AsyncComponent} from '@modifi/code-splitting'
import {FullScreenLoader} from '@modifi/ui'

export const ExistingSellerTradePartnersPage = AsyncComponent({
  importThunk: () =>
    import(/* webpackChunkName: "seller-trade-partners" */ './existing-seller-trade-partners'),
  loader: FullScreenLoader,
})

export const CreateSellerTradePartnersPage = AsyncComponent({
  importThunk: () =>
    import(/* webpackChunkName: "seller-trade-partners" */ './create-seller-trade-partner'),
  loader: FullScreenLoader,
})

export const SellerTradePartnerSummaryPage = AsyncComponent({
  importThunk: () =>
    import(/* webpackChunkName: "seller-trade-partners" */ './seller-trade-partner-summary'),
  loader: FullScreenLoader,
})
